import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

export const scopes = ["api://fc6b72c0-fa2c-4b84-9d5c-dfa2b1cfffcc/Read"];
export const authority = "https://login.microsoftonline.com/a891c7dd-26b3-4449-8f2c-3fb8ee16ef12";

export async function acquireApiToken(
    instance: IPublicClientApplication,
    account: AccountInfo | null
) {
    if (account) {
        return instance.acquireTokenSilent({
            scopes: scopes,
            account,
            authority: authority,
        });
    }
}